<section id="main-section">
  <section id="section1">
    <div class="container">
      <div class="logo text-center">
        <a href="javascript:void(0)">
          <img src="{{ onPassiveBaseUrl }}onpassive-sept(5)/images/logo1.png" />
        </a>
      </div>
    </div>
  </section>

  <section id="section2">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <div class="contents mb-md-4">
            <div class="contents">
              <h3 class="font-weight-bold animation animations">
                <span style="animation-delay: 0s">N</span
                ><span style="animation-delay: 0.1s">E</span
                ><span style="animation-delay: 0.2s">W</span>
                <span style="animation-delay: 0.3s">R</span
                ><span style="animation-delay: 0.4s">E</span
                ><span style="animation-delay: 0.5s">V</span
                ><span style="animation-delay: 0.6s">O</span
                ><span style="animation-delay: 0.7s">L</span
                ><span style="animation-delay: 0.8s">U</span
                ><span style="animation-delay: 0.9s">T</span
                ><span style="animation-delay: 1s">I</span
                ><span style="animation-delay: 1.1s">O</span
                ><span style="animation-delay: 1.2s">N</span
                ><span style="animation-delay: 1.3s">I</span
                ><span style="animation-delay: 1.4s">Z</span
                ><span style="animation-delay: 1.5s">E</span
                ><span style="animation-delay: 1.6s">D</span>
              </h3>
              <h4
                class="text-uppercase"
                data-aos="fade-up"
                data-aos-delay="1000"
              >
                Internet Marketing Solutions
              </h4>
            </div>
          </div>
        </div>
      </div>

      <!--	<h1 class="text-white text-center text-uppercase" data-aos="flip-left" >launching soon</h1>-->
    </div>
  </section>

  <section id="section3" data-aos="fade-up" data-aos-delay="1500">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-6 col-lg-8">
          <div class="video-box">
            <video
              id="my-video"
              class="video-js video-size w-100 h-auto"
              controls
              preload="auto"
              poster="{{ myLinksS3URL }}images/Image0231.png"
              data-setup="{}"
              autoplay="true"
              muted
            >
              <source
                src="{{
                  myLinksS3URL
                }}videos/Onpassive_launching_page_video.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </div>

        <div class="col-xl-4 col-lg-8">
          <div class="content">
            <div class="content-inner">
              <p>
                It takes an entire life to be happy. But why waste a whole life
                in search for happiness when the key is in your hand. ONPASSIVE
                is the miracle income generating platform that will give you
                happiness which you have always searched. The best thing about
                this platform is that it is totally automated. Even if you are
                not tech savvy or not a tech wizard, this platform is for all.
                Come join us now and be happy!
              </p>

              <div class="button">
                <a
                  href="/registration/user?reg={{ userId }}"
                  class="btn-founder"
                  name="regform"
                  target="_blank"
                  rel="noopener"
                >
                  <span>Become a Founder </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="section4" class="pt-4">
    <div class="container">
      <div class="text-effect">
        <span>L</span>
        <span>A</span>
        <span>U</span>
        <span>N</span>
        <span>C</span>
        <span>H</span>
        <span>I</span>
        <span>N</span>
        <span> G </span>
        <span> &nbsp;</span>
        <span> &nbsp;</span>
        <span>S</span>
        <span>O</span>
        <span>O</span>
        <span>N</span>
      </div>
    </div>
  </section>
</section>
